// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tW7A1","mainView":"styles_mainView__1NkYt"};